// Columna «Cadena» del Alcance, igual en promos de venta y de referido: al crear, quien abarca el
// silo elige varias cadenas; al editar o con una sola cadena, la cadena va fija.
import { useId } from 'react';
import {
    RETAILER_CREATED_LEGEND,
    RETAILER_SCOPE_HELP,
    RETAILER_SCOPE_TITLE,
    RETAILERS_EMPTY_LABEL,
    RETAILERS_LOADING_LABEL,
} from './labels';
import { ScopeChip, ScopeChipGroup, ScopeChipStatic } from './ScopeChips';

export interface RetailerScopeOption {
    value: string;
    label: string;
}

export type RetailerScopeColumnProps =
    | {
          mode: 'choose';
          options: readonly RetailerScopeOption[];
          selected: readonly string[];
          onToggle: (retailerId: string) => void;
          /** Cadenas donde la copia ya se creó: no se vuelven a crear al reintentar. */
          createdIds?: readonly string[];
          loading?: boolean;
          error?: string;
      }
    | { mode: 'fixed'; label: string };

export function RetailerScopeColumn(props: RetailerScopeColumnProps) {
    const errorId = useId();
    if (props.mode === 'fixed') {
        return (
            <ScopeChipGroup title={RETAILER_SCOPE_TITLE} help={RETAILER_SCOPE_HELP}>
                <ScopeChipStatic dim="retailer" label={props.label} />
            </ScopeChipGroup>
        );
    }
    const { options, selected, onToggle, createdIds = [], loading, error } = props;
    return (
        <ScopeChipGroup
            title={RETAILER_SCOPE_TITLE}
            help={RETAILER_SCOPE_HELP}
            describedBy={error ? errorId : undefined}
            invalid={error !== undefined}
            footer={
                error ? (
                    <p id={errorId} role="alert" className="mt-1.5 text-[10.5px] text-destructive">
                        {error}
                    </p>
                ) : null
            }
        >
            {options.map((option) => {
                const created = createdIds.includes(option.value);
                return (
                    <ScopeChip
                        key={option.value}
                        dim="retailer"
                        label={option.label}
                        detail={created ? RETAILER_CREATED_LEGEND : undefined}
                        selected={created || selected.includes(option.value)}
                        disabled={created}
                        onToggle={() => {
                            onToggle(option.value);
                        }}
                    />
                );
            })}
            {options.length === 0 ? (
                <p className="text-[10.5px] text-muted-foreground">
                    {loading ? RETAILERS_LOADING_LABEL : RETAILERS_EMPTY_LABEL}
                </p>
            ) : null}
        </ScopeChipGroup>
    );
}
